import {
  array,
  blob,
  type InferOutput,
  minLength,
  number,
  object,
  optional,
  pipe,
  string,
  trim,
  union,
} from "valibot";

const attachmentsSchema = array(
  object({
    id: string(),
    name: string(),
    url: string(),
    media_type: string(),
    byte_size: number(),
  }),
);

export const InboxMessageSchema = union([
  object({
    message: pipe(string(), trim(), minLength(1, "Message is required")),
    attachments: optional(attachmentsSchema),
  }),
  object({ attachments: attachmentsSchema }),
  object({
    audio: blob(),
  }),
]);

export type InboxMessageSchemaType = InferOutput<typeof InboxMessageSchema>;
